exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_empty__cov6k {\n  font-size: 1.2rem;\n  color: gray;\n  display: flex;\n  justify-content: center;\n  margin: .5rem 0;\n}\n", ""]);

// Exports
exports.locals = {
	"empty": "styles_empty__cov6k"
};